import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BankApi } from 'api';

export const findBank = createAsyncThunk(
  'bank/findBank',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BankApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findMasterDataBank = createAsyncThunk(
  'bank/findMasterDataBank',
  async (_, { rejectWithValue }) => {
    try {
      const response = await BankApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  isLoaded: boolean;
}

const initialState: IState = {
  list: [],
  isLoaded: false,
};

const bankSlice = createSlice({
  name: 'bank',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findBank.fulfilled, (state, action) => {
      const { data } = action.payload;

      state.list = data;
    });
    builder.addCase(findMasterDataBank.fulfilled, (state, action) => {
      const { data } = action.payload;

      const formatData = data.map(item => {
        return {
          ...item,
          name: `${item.tradingName} - ${item.name}`,
          value: item.id,
        };
      });

      state.list = formatData;

      state.isLoaded = true;
    });
  },
});

const { reducer: bankReducer } = bankSlice;

export default bankReducer;
